import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const LeistungenPage = lazy(() => import('../pages/leistungen/page'));
const VorteilePage = lazy(() => import('../pages/vorteile/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/leistungen',
    element: <LeistungenPage />,
  },
  {
    path: '/vorteile',
    element: <VorteilePage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;